import type {AuthenticationSystemView, LoginView} from '../kp-login';
import type {LoginComponentController} from '../kp-login.component';

export default abstract class AbstractLoginSystemController {
    public loginView: LoginView;
    public authSystemView: AuthenticationSystemView;
    public loginController: LoginComponentController;
}
